<template>
  <div class="assignment-add">
    <addTaskInfo :formInfo='formInfo' :nature='nature' :warehouseCode='warehouseCode'></addTaskInfo>
    <el-card shadow="hover">
      <h3>商品信息</h3>
      <div class="wrap" style="padding: 20px 0 0">
        <!-- 列表 S -->
        <page-table permission="assignmentManage"
                    :list="goodsList"
                    :fieldList="fieldList2"
                    :add="add"
                    deleteName="id"
                    :btns="['add','handle']"
                    :handleSlot="true">
          <template v-slot:col-num1="scope">
            <span v-if="isProductionTime(scope.row)">{{ scope.row.num1 }}</span>
            <el-input v-else @mousewheel.native.prevent style="width: 75px!important" type="number" v-model="scope.row.num1" :oninput="`if(value<0){value=0}else{value=parseInt(value)}`"></el-input>件
          </template>
          <template v-slot:col-wornNum="scope">
            <span v-if="isProductionTime(scope.row) && (formInfo.data.type=='TASK_TYPE_EMPTY' || formInfo.data.type=='TASK_TYPE_OTHER_OUT')">{{ scope.row.wornNum }}</span>
            <el-input v-else @mousewheel.native.prevent style="width: 75px!important" type="number" v-model="scope.row.wornNum"  :oninput="`if(value<0){value=0}else{value=parseInt(value)}`"></el-input>件
          </template>
          <template v-slot:col-inventory="scope">
            <div class="inventory">
              <div>{{scope.row.inventory}}{{ scope.row.minUnitName }}</div>
              <div>({{ Math.floor(scope.row.inventory / scope.row.box) }}{{ scope.row.maxUnitName }}{{ scope.row.inventory % scope.row.box }}{{ scope.row.minUnitName }})</div>
            </div>
          </template>
          <template v-slot:col-unavailable="scope" >
            <div class="inventory">
              <div>{{scope.row.unavailable}}{{ scope.row.minUnitName }}</div>
              <div>({{ Math.floor(scope.row.unavailable / scope.row.box) }}{{ scope.row.maxUnitName }}{{ scope.row.unavailable % scope.row.box }}{{ scope.row.minUnitName }})</div>
            </div>
          </template>
          <template v-slot:handleSlot="scope">
            <div class="handle-btn">
              <!-- 出库任务新增 - 选择生产日期 -->
              <slot v-if="isProductionTime(scope.row)" name="productionDate" :index="scope.index"></slot>
              <el-button type="text" @click="deleteMember(scope.index, scope.row)" :disabled="$has('assignmentManageAdd')">删除</el-button>
            </div>
          </template>
        </page-table>
        <!-- 列表 E -->
      <div style="display:flex" v-if="goodsList.rows">
        <label style="margin-left: auto;color: #696969;">计划总数：SKU种数{{ goodsList.rows.length }}，共{{skuTotal}}件</label>
      </div>
      </div>
    </el-card>

    <div class="page-submit" v-if="!$has('assignmentManageAdd')">
        <el-button type="primary" @click="submitConfig" :disabled="isAddBtnDis">保存</el-button>
    </div>

    <!-- 弹窗 -->
    <el-dialog :title="formDialog.title" :visible.sync="formDialog.visibel" :show-close="false">
      <el-row style="margin-bottom: 20px">
        <el-col :span="15">
          <el-input style="width: 180px!important" clearable v-model="dialogSearch.name" placeholder="请输入商品名称"></el-input>
          <el-input style="width: 180px!important" clearable v-model="dialogSearch.goodsCode" placeholder="输入商品编码"></el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="getList()">查询</el-button>
        </el-col>
      </el-row>

      <!-- 列表 S -->
      <page-table ref='pageTable'
                  permission="lessionTable"
                  :list="assignmentAddList"
                  :fieldList="fieldList1"
                  :selection="true"
                  deleteName="id"
                  :reserveSelection="true"
                  :selectable="selectable"
                  rowKey="goodsCode">
        <template v-slot:col-inventory="scope">
          <div>{{scope.row.inventory}}{{ scope.row.minUnitName }}</div>
          ({{ Math.floor(scope.row.inventory / scope.row.box) }}{{ scope.row.maxUnitName }}{{ scope.row.inventory % scope.row.box }}{{ scope.row.minUnitName }})
        </template>
        <template v-slot:col-unavailable="scope">
          <div>{{scope.row.unavailable}}{{ scope.row.minUnitName }}</div>
          ({{ Math.floor(scope.row.unavailable / scope.row.box) }}{{ scope.row.maxUnitName }}{{ scope.row.unavailable % scope.row.box }}{{ scope.row.minUnitName }})
        </template>
      </page-table>
      <!-- 列表 E -->

      <div slot="footer" class="dialog-footer">
        <el-button @click="edit(false)">取 消</el-button>
        <el-button type="primary" @click="edit(true)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageTable from '@/components/Table/Index'
import { DICTGETCHILDS } from '@/store/goodsManage/types.js'
import assignmentManage from '@/store/assignmentManage/index.js'
import {TASKGETGOODS, TASKADD} from '@/store/assignmentManage/types'
import {CLOSECURRENTTAG} from '@/store/user/types'
import addTaskInfo from '@/page/assignmentManage/components/addTaskInfo'
import user from '@/store/user/index'
export default {
  props: {
    nature: {
      type: String,
      default: '2'
    },
    warehouseCode: {
      type: String,
      default: null
    }
  },
  name: 'warehouseintoadd',
  data () {
    return {
      dialogSearch: {
        name: '',
        goodsCode: ''
      },
      formInfo: {
        ref: null,
        data: {
          supplierCode: '',
          type: '',
          loading: '',
          ydppCode: '', // 配送仓点
          note: ''// 备注
        },
        rules: {},
        labelWidth: '120px'
      },
      formDialog: {
        title: '添加商品',
        visibel: false
      },
      goodsList: {
        rows: []
      },
      isAddBtnDis: false
    }
  },
  components: {
    pageTable,
    addTaskInfo
  },
  watch: {
    assignmentAddMark: {
      deep: true,
      handler (val) {
        if (val === 1) {
          assignmentManage.state.assignmentAddMark = 0
          if (this.nature === '1') {
            this.$store.dispatch('tagsView/setBeforePageName', 'warehouseout')
            this.$store.dispatch(CLOSECURRENTTAG, '/assignmentmanage/warehouseout')
          } else {
            this.$store.dispatch('tagsView/setBeforePageName', 'warehouseinto')
            this.$store.dispatch(CLOSECURRENTTAG, '/assignmentmanage/warehouseinto')
          }
        }
      }
    },
    // 切换供应商 需重新选择商品
    'formInfo.data.supplierCode': {
      deep: true,
      handler (val) {
        this.goodsList.rows = []
      }
    }
  },
  computed: {
    // tabel列表
    assignmentAddList () {
      return assignmentManage.state.assignmentAddList
    },
    // 获取弹窗表格
    pageTable () {
      return this.$refs.pageTable.$refs.table
    },
    assignmentAddMark () {
      return assignmentManage.state.assignmentAddMark
    },
    // sku总数
    skuTotal () {
      let num = 0
      this.goodsList.rows.forEach(item => {
        num += parseInt(item.num1) + parseInt(item.wornNum)
      })
      return num
    },
    fieldList1 () {
      let arr = [
        { label: '商品名称', prop: 'name', width: 150 },
        { label: '商品属性', prop: 'typeName', width: 150 },
        { label: '规格', prop: 'standard', width: 150 },
        { label: '箱规（件/箱）', prop: 'box', width: 150 },
        { label: '可用库存', prop: 'inventory', width: 150, type: 'slot' },
        { label: '不可用库存', prop: 'unavailable', width: 150, type: 'slot' },
        { label: '商品编码', prop: 'goodsCode', width: 150 },
        { label: '供应商', prop: 'supplier', width: 150 }
      ]
      // 开启生产日期管理
      if (this.userinfo.isMdOpen === 1) {
        arr.splice(4, 0, { label: '保质期（天）', prop: 'expDays', width: 150 })
      }
      return arr
    },
    fieldList2 () {
      let ary = [
        { label: '商品名称', prop: 'name', width: 150 },
        { label: '商品属性', prop: 'typeName', width: 150 },
        { label: '规格', prop: 'standard', width: 150 },
        { label: '箱规（件/箱）', prop: 'box', width: 150 },
        { label: '可用库存', prop: 'inventory', width: 150, type: 'slot' },
        { label: '不可用库存', prop: 'unavailable', width: 150, type: 'slot' },
        { label: '计划数量（正常品）', prop: 'num1', width: 250, type: 'slot' },
        { label: '计划数量（破损品）', prop: 'wornNum', width: 250, type: 'slot' },
        { label: '商品条码', prop: 'barCode', width: 150 },
        { label: '商品编码', prop: 'goodsCode', width: 150 },
        { label: '供应商', prop: 'supplier', width: 150 }
      ]
      if (this.formInfo.data.type !== 'TASK_TYPE_EMPTY' && this.formInfo.data.type !== 'TASK_TYPE_OTHER_OUT') {
        ary.splice(7, 1)
      }
      return ary
    },
    // 选中的商品code
    checkListIds () {
      return this.goodsList.rows.map(item => item.goodsCode)
    },
    userinfo () {
      return user.state.userinfo
    }

  },
  mounted () {
    // 初始化表单验证
    this.formInfo.rules = this.$initRules(this.fieldList1)
    this.getSelect()
  },
  methods: {
    // 是否为出库任务 并且 开启生产日期
    isProductionTime (row) {
      if (!(window.localStorage.getItem('identity') === '1')) {
        return row.openStatus === 1 && this.nature === '1'
      }
      return row.openStatus === 1 && this.userinfo.isMdOpen === 1 && this.nature === '1'
    },
    // 获取列表
    getList () {
      if (this.formDialog.visibel) {
        this.pageTable.clearSelection()
        this.setSelection()
      }
      let {name, goodsCode} = this.dialogSearch
      let params = {
        supplierCode: this.formInfo.data.supplierCode,
        type: this.formInfo.data.type,
        name,
        goodsCode,
        warehouseCode: this.warehouseCode || this.$route.params.warehouseCode
      }
      this.$store.dispatch(TASKGETGOODS, params)
    },
    // 获取下拉框
    getSelect () {
      let params = {
        parentCode: 'TASK_TYPE'
      }
      this.$store.dispatch(DICTGETCHILDS, params)
    },
    // 新增
    add () {
      if (!this.formValid()) return false

      this.getList()
      this.formDialog = {
        title: '添加商品',
        visibel: true
      }
      this.setSelection()
    },
    // table设置禁用
    selectable ({ goodsCode }) {
      if (this.checkListIds.indexOf(goodsCode) > -1) {
        return false
      }
      return true
    },
    // table设置选中
    setSelection () {
      let goodsList = JSON.parse(JSON.stringify(this.goodsList.rows))
      this.$nextTick(() => {
        goodsList.forEach(item => {
          this.pageTable.toggleRowSelection(item)
        })
      })
    },
    // 确定
    edit (type) {
      // 取消
      if (!type) return this.handleClose()

      if (this.pageTable.selection.length > 0) {
        let goodsListStr = JSON.stringify(this.goodsList.rows)
        this.pageTable.selection.forEach(item => {
          if (goodsListStr.indexOf(item.goodsCode) === -1) {
            this.goodsList.rows.push(item)
          }
        })
      }
      this.handleClose()
    },
    // 删除
    deleteMember (index, row) {
      this.goodsList.rows.splice(index, 1)
    },
    // 保存
    submitConfig () {
      if (!this.formValid()) return false
      if (this.goodsList.rows.length === 0) {
        return this.$message.error('请选择商品')
      }
      for (let i = 0; i < this.goodsList.rows.length; i++) {
        let {num1, wornNum, inventory, unavailable} = this.goodsList.rows[i]
        if (num1 === '') num1 = 0
        if (wornNum === '') wornNum = 0
        if (num1 === '' || num1 === undefined || (((parseInt(wornNum) + parseInt(num1))) === 0)) {
          return this.$message.error('请填写 计划数量')
        }
        if (this.formInfo.data.type === 'TASK_TYPE_EMPTY' || this.formInfo.data.type === 'TASK_TYPE_OTHER_OUT') {
          if (num1 === '' || num1 === undefined || (((parseInt(wornNum) + parseInt(num1))) === 0) ||
            (num1 === '' && wornNum === 0) || (num1 === 0 && wornNum === '')) {
            return this.$message.error('请填写 计划数量')
          }
        }
        if (this.formInfo.data.type === 'TASK_TYPE_ARRIVE' || this.formInfo.data.type === 'TASK_TYPE_REMAINING' || this.formInfo.data.type === 'TASK_TYPE_AFTER' || this.formInfo.data.type === 'TASK_TYPE_OTHER_PUT') {
        } else {
          // if (parseInt(num1) * box + parseInt(num2) > inventory) {
          if (parseInt(num1) > inventory) {
            return this.$message.error('计划数量 不能超过 可用库存(正常品)')
          } else if (parseInt(wornNum) > unavailable) {
            return this.$message.error('计划数量 不能超过 可用库存(破损品)')
          }
        }
      }

      this.formInfo.ref.validate((valid) => {
        if (valid) {
          let {supplierCode, type, loading, ydppCode, note} = this.formInfo.data
          let params = {
            task: {
              supplierCode,
              note,
              ydppCode: ydppCode,
              taskType: type,
              loading: loading || '',
              warehouseCode: this.warehouseCode || this.$route.params.warehouseCode
            },
            goodsList: []
          }
          this.goodsList.rows.forEach((item) => {
            let result = {
              goodsCode: item.goodsCode,
              num: parseInt(item.num1),
              wornNum: item.wornNum ? parseInt(item.wornNum) : 0,
              batchList: item.batchList ? item.batchList : undefined
            }
            params.goodsList.push(result)
          })
          // 出库任务 - 生产日期（如果生产日期为无，则清空）
          if (this.nature === '1') {
            params.goodsList.forEach(item => {
              if (item.batchList && item.batchList.length > 0) {
                item.batchList.forEach(v => {
                  if (v.ytgbProductionTime === '无') {
                    v.ytgbProductionTime = ''
                  }
                })
              }
            })
          }
          this.isAddBtnDis = true
          this.$store.dispatch(TASKADD, JSON.stringify(params)).then(() => {
            this.isAddBtnDis = false
            assignmentManage.state.rollsHomeworkMark = 1
            // this.getList()
            // if (this.nature === '1') {
            //   this.$router.push('/assignmentmanage/warehouseout')
            // } else {
            //   this.$router.push('/assignmentmanage/warehouseinto')
            // }
          })
        }
      })
    },
    // 填写验证
    formValid () {
      console.log(this.formInfo.data, 'formInfo')
      let {supplierCode, type, loading, ydppCode} = this.formInfo.data
      if (!supplierCode || supplierCode === '' || !type || type === '') {
        this.$message.warning('请先选择 供应商 和 任务类型')
        return false
      }
      if (type === 'TASK_TYPE_ARRIVE' || type === 'TASK_TYPE_EMPTY' || type === 'TASK_TYPE_OTHER_PUT' || type === 'TASK_TYPE_OTHER_OUT') {
        if (!loading || loading === '' || loading === undefined) {
          this.$message.warning('请选择 装卸服务')
          return false
        }
      }
      if (type === 'TASK_TYPE_REMAINING' || type === 'TASK_TYPE_AFTER' || type === 'TASK_TYPE_SEND' || type === 'TASK_TYPE_CPFR') {
        if (!ydppCode || ydppCode === '' || ydppCode === undefined) {
          this.$message.warning('请选择 配送仓点')
          return false
        }
      }
      return true
    },
    // 关闭弹窗
    handleClose () {
      this.pageTable.clearSelection()
      this.formDialog.visibel = false
    }
  }
}
</script>

<style scoped>
  .page-submit {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: right;
    padding: 20px 120px;
    background: #fff;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/page/assignmentManage/warehouse/warehouseIntoAdd.vue